export enum InventoryFileTypeEnum {
	Import = 1,
	Export = 2,
}
